<template>
  <div>
    <div>
      <v-card class="pl-3 pr-3" style="height: 62px" outlined shaped tile>
        <v-row>
          <v-col md="12">
            <v-row no-gutters>
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    style="max-width: 300px"
                    v-model="date"
                    label="Selecione Mês e Ano"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker locale="pt-br" @change="atualizarDados()" v-model="date" type="month" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
              <v-btn @click="atualizarDados()" class="fs-btns-crud-grid ml-2" style="margin-top: 2px" height="32px"
                     color="primary" outlined small>
                <v-icon class="mr-1">
                  mdi-refresh
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn :disabled="!items.length" @click="exportarExcel()" class="fs-btns-crud-grid ml-2"
                     style="margin-top: 2px" height="32px" color="primary" outlined small>
                <v-icon class="mr-1">
                  mdi-file-excel
                </v-icon>
                Exp. p/ Excel
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card v-if="items.length" style="border-top-right-radius: 20px;" class="mt-2" outlined tile>
        <v-data-table
          :loading="loading"
          loading-text="Carregando, aguarde..."
          :headers="headers"
          :items="items"
          :items-per-page="99999999"
          :sort-desc="false"
          hide-default-footer
          hide-action
          sort-by="id"
          item-key="id"
        >
          <template v-slot:body="{ items }">
            <tr v-for="row in items" :key="row.id">
              <td>{{ String(row.dia).padStart(2, '0') }}</td>
              <td>{{ row.vendas | formatCurrency }}</td>
              <td>{{ row.compras | formatCurrency }}</td>
              <td>{{ row.impostos | formatCurrency }}</td>
              <td>{{ row.percas | formatCurrency }}</td>
              <td>{{ row.lucro | formatCurrency }}</td>
              <td>{{ parseFloat(row.rentabilidade).toFixed(2) }}%</td>
              <td>
                <v-btn class="ml-2" @click="atualizarDadosDetalhe(row.dia)" icon>
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr style="background-color: #EEEEEE">
              <td><b>TOTAL</b></td>
              <td><b>{{ totais.vendas | formatCurrency }}</b></td>
              <td><b>{{ totais.compras | formatCurrency }}</b></td>
              <td><b>{{ totais.impostos | formatCurrency }}</b></td>
              <td><b>{{ totais.percas | formatCurrency }}</b></td>
              <td><b>{{ totais.lucro | formatCurrency }}</b></td>
              <td><b>100%</b></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-dialog width="400px" v-model="dialogExcel">
      <v-card>
        <v-card-title>
          Seu arquivo está pronto!
        </v-card-title>
        <v-card-text>
          Faça o download clicando no botão abaixo.
        </v-card-text>
        <v-divider class="ma-0 "/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#2A2F50" download="report.csv" :href="linkExcel" @click="dialogExcel = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-download</v-icon>
            Fazer Download
          </v-btn>
          <v-btn color="warning" @click="dialogExcel = false" dark small>
            <v-icon class="mr-1" style="font-size: 15px !important">mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="dialogDetalhes" max-width="1170px">
      <v-card class="pt-2">
        <v-row no-gutters>
          <v-btn @click="exportarExcel2()" :disabled="!itemDetalhes.length" class="fs-btns-crud-grid ml-2"
                 style="margin-top: 2px" height="32px" color="primary" outlined small>
            <v-icon class="mr-1">
              mdi-file-excel
            </v-icon>
            Exp. p/ Excel
          </v-btn>
          <v-spacer/>
          <v-btn @click="dialogDetalhes = false" class="mr-2" icon>
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-row>
        <v-card class="mt-2" outlined tile>
          <v-data-table
            :loading="loading"
            loading-text="Carregando, aguarde..."
            :headers="headersDetalhes"
            :items="itemDetalhes"
            :items-per-page="99999999"
            :sort-desc="false"
            hide-default-footer
            hide-action
            sort-by="id"
            item-key="id"
          >
            <template v-slot:body="{ items }">
              <tr v-for="row in items" :key="row.id">
                <td>{{ row.data | formatarData }}</td>
                <td>{{ row.pedido }}</td>
                <td>{{ row.item }}</td>
                <td>{{ row.cliente }}</td>
                <td>{{ row.preco | formatCurrency }}</td>
                <td>{{ row.subtotal | formatCurrency }}</td>
                <td>{{ row.lucro | formatCurrency }}</td>
                <td>{{ parseFloat(row.rentabilidade).toFixed(2) }}%</td>
              </tr>
              <tr style="background-color: #EEEEEE">
                <td><b>TOTAL</b></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td><b>{{ totaisDetalhes.subtotal | formatCurrency }}</b></td>
                <td><b>{{ totaisDetalhes.lucro | formatCurrency }}</b></td>
                <td><b>100%</b></td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as api from '@/api/lucratividade'
import { mapMutations } from 'vuex'
import moment from 'moment'

export default {
  filters: {
    formatarData (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    formatCurrency (number) {
      return number.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    }
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      items: [],
      itemDetalhes: [],
      dialogExcel: false,
      linkExcel: null,
      loading: false,
      dialogDetalhes: false,
      headers: [
        { text: 'DIA', value: 'dia' },
        { text: 'VENDAS', value: 'vendas' },
        { text: 'COMPRAS', value: 'compras' },
        { text: 'IMPOSTOS', value: 'impostos' },
        { text: 'PERCAS', value: 'percas' },
        { text: 'LUCRO BRUTO', value: 'lucro' },
        { text: 'RENTABILIDADE', value: 'rentabilidade' },
        { text: 'DETALHES', sortable: false }
      ],
      headersDetalhes: [
        { text: 'DATA', value: 'data' },
        { text: 'PEDIDO', value: 'pedido' },
        { text: 'ITEM', value: 'item' },
        { text: 'CLIENTE', value: 'cliente' },
        { text: 'PREÇO', value: 'preco' },
        { text: 'SUBTOTAL', value: 'subtotal' },
        { text: 'LUCRO BRUTO', value: 'lucro' },
        { text: 'RENTABILIDADE', value: 'rentabilidade' }
      ],
      totaisDetalhes: {
        subtotal: 0,
        lucro: 0
      },
      totais: {
        vendas: 0,
        compras: 0,
        impostos: 0,
        percas: 0,
        lucro: 0
      }
    }
  },
  mounted () {
    this.atualizarDados()
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'global/setSnackbar'
    }),
    async atualizarDadosDetalhe (dia) {
      this.loading = true
      try {
        this.zerarTotaisDetalhes()
        const data = this.date + '-' + String(dia).padStart(2, '0')
        this.itemDetalhes = await api.buscarDadosTabelaDetalhesDia({ data })
        for (const item of this.itemDetalhes) {
          this.totaisDetalhes.subtotal += item.subtotal
          this.totaisDetalhes.lucro += item.lucro
        }
        this.dialogDetalhes = true
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
      this.loading = false
    },
    async atualizarDados () {
      try {
        this.loading = true
        this.zerarTotais()
        this.items = await api.buscarDadosTabela({ anoMes: this.date })
        // console.log(this.items)
        for (const item of this.items) {
          this.totais.vendas += item.vendas
          this.totais.compras += item.compras
          this.totais.impostos += item.impostos
          this.totais.percas += item.percas
          this.totais.lucro += item.lucro
        }
        if (this.items.length) {
          this.setSnackbar({ msg: 'Os dados foram atualizados!', color: 'green' })
        } else {
          this.setSnackbar({ msg: 'Não há dados disponíveis. Verifique o mês informado.', color: 'red' })
        }
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
      this.loading = false
    },
    zerarTotais () {
      this.totais.vendas = 0
      this.totais.compras = 0
      this.totais.impostos = 0
      this.totais.percas = 0
      this.totais.lucro = 0
    },
    zerarTotaisDetalhes () {
      this.totaisDetalhes.subtotal = 0
      this.totaisDetalhes.lucro = 0
    },
    async exportarExcel () {
      this.loading = true
      try {
        setTimeout(async () => {
          const csvString = await api.exportarParaExcel(this.items)
          const universalBOM = '\uFEFF'
          this.linkExcel = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString)
          this.dialogExcel = true
          this.downloadExcel = true
          this.loading = false
        }, 700)
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
    },
    async exportarExcel2 () {
      this.loading = true
      try {
        setTimeout(async () => {
          const csvString = await api.exportarParaExcelDetalhes(this.itemDetalhes)
          const universalBOM = '\uFEFF'
          this.linkExcel = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + csvString)
          this.dialogExcel = true
          this.downloadExcel = true
          this.loading = false
        }, 700)
      } catch (error) {
        this.setSnackbar({ msg: error, color: 'red' })
      }
    }
  }
}
</script>

<style scoped>
.fs-btns-crud-grid {
  padding: 3px 7px 3px 7px !important;
  margin-left: 10px;
}

.fs-btns-crud-grid:active {
  border: 1px solid rgb(122, 122, 122) !important;
}
</style>
